export const ORDER_DETAILS = (
    "https://groww-intern-assignment.vercel.app/v1/api/order-details");

export const MERCHANT_METADATA = (
    "https://groww-intern-assignment.vercel.app/v1/api/merchant-metadata");